import React from "react";
import MUIStep from "@mui/material/Step";
import MUIStepButton from "@mui/material/StepButton";
import MUIStepper from "@mui/material/Stepper";
import { getClassName } from "@sscs/utils";
import styles from "./dialog.module.scss";
/**
 * The band between Header and Body: a stepper on a tinted surface reading as chrome. Presentational —
 * the caller owns the step model and gates reachable steps via each step's `isDisabled`.
 */
const Stepper = ({ steps, activeStep, onStepChange, className, }) => (React.createElement(MUIStepper, { className: getClassName(styles.stepper, className), activeStep: activeStep }, steps.map((step, stepIndex) => (React.createElement(MUIStep, { key: step.label, completed: stepIndex < activeStep, classes: { completed: styles["completed-step"] } },
    React.createElement(MUIStepButton, { onClick: onStepChange && (() => onStepChange(stepIndex)), disabled: step.isDisabled }, step.label))))));
/** The `Step 3 of 5` text for a stepped dialog's footer. Put it in `Dialog.Footer.Meta`. */
const StepCounter = ({ current, total, }) => (React.createElement("span", null,
    "Step ",
    current,
    " of ",
    total));
export { StepCounter };
export default Stepper;
//# sourceMappingURL=DialogStepper.js.map